var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResourceAugmentation4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2071.35 1349.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#bdd0fb;}.cls-3{fill:#91b3fa;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#f0f0f0;}.cls-6{fill:#7d97f4;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:#2b69b3;}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#linear-gradient-7);}.cls-13{fill:#18174a;}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-9);}.cls-16{opacity:0.61;}.cls-17{fill:#fff;}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{opacity:0.59;}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{opacity:0.51;}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-20);}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}.cls-35{fill:url(#linear-gradient-25);}.cls-36{fill:url(#linear-gradient-26);}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{fill:url(#linear-gradient-31);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-33);}.cls-44{fill:url(#linear-gradient-34);}.cls-45{fill:url(#linear-gradient-35);}.cls-46{fill:url(#linear-gradient-36);}.cls-47{fill:url(#linear-gradient-37);}.cls-48{fill:url(#linear-gradient-38);}.cls-49{fill:url(#linear-gradient-39);}.cls-50{fill:url(#linear-gradient-40);}.cls-51{fill:url(#linear-gradient-41);}.cls-52{fill:url(#linear-gradient-42);}.cls-53{fill:url(#linear-gradient-43);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.2,
    y1: 572.3,
    x2: 2044.62,
    y2: 572.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1971.36,
    y1: 656.27,
    x2: 2044.92,
    y2: 656.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 20.75,
    y1: 806.06,
    x2: 80.17,
    y2: 806.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1321.15,
    y1: 313.7,
    x2: 1845.38,
    y2: 313.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1419.94,
    y1: 313.7,
    x2: 1746.59,
    y2: 313.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1803.74,
    y1: 20.98,
    x2: 1233.91,
    y2: 777.52,
    gradientTransform: "translate(1595.18 -1300.3) rotate(79.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1514.45,
    y1: 313.7,
    x2: 1652.08,
    y2: 313.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1783.8,
    y1: 805.92,
    x2: 1408.76,
    y2: 934.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1302.22,
    y1: 1050.37,
    x2: 2007.28,
    y2: 459.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1137.55,
    y1: 889.95,
    x2: 837.52,
    y2: 1126.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 662.31,
    y1: 1405.9,
    x2: 953.34,
    y2: 862.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 704.14,
    y1: 813.88,
    x2: 809.2,
    y2: 813.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 704.14,
    y1: 889.15,
    x2: 708.23,
    y2: 889.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 444.68,
    y1: 1152.88,
    x2: 228.66,
    y2: 1362.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 34.66,
    y1: 1469.3,
    x2: 487.71,
    y2: 1031.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 345.18,
    y1: 637.25,
    x2: 567.18,
    y2: 405.25,
    gradientTransform: "translate(431.48 -227.8) rotate(-9.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 367.61,
    y1: 658.71,
    x2: 589.61,
    y2: 426.71,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 994.9,
    y1: 192.04,
    x2: 994.9,
    y2: 484.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -78.95,
    y1: 940.72,
    x2: -42.91,
    y2: 940.72,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 408.24,
    y1: 824.75,
    x2: 447.84,
    y2: 824.75,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 560.43,
    y1: 107.7,
    x2: 624.43,
    y2: 337.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 655.63,
    y1: 448.84,
    x2: 682.62,
    y2: 273.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 778.8,
    y1: 110.25,
    x2: 712.8,
    y2: 310.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 995.9,
    y1: -113.97,
    x2: 1003.9,
    y2: 24.03,
    gradientTransform: "translate(-230.96 95.68) rotate(3.85)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 969.63,
    y1: -112.45,
    x2: 977.63,
    y2: 25.55,
    gradientTransform: "translate(-230.96 95.68) rotate(3.85)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -188.74,
    y1: 931.04,
    x2: -209.39,
    y2: 971.65,
    gradientTransform: "matrix(-0.98, -0.22, -0.22, 0.98, 1489.45, 81.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -213.62,
    y1: 918.9,
    x2: -193.05,
    y2: 918.9,
    gradientTransform: "matrix(-0.98, -0.22, -0.22, 0.98, 1489.45, 81.28)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1479.59,
    y1: 1006.95,
    x2: 1473.59,
    y2: 1060.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -222.16,
    y1: 964.07,
    x2: -166.84,
    y2: 964.07,
    gradientTransform: "matrix(-0.98, -0.22, -0.22, 0.98, 1489.45, 81.28)",
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -228.49,
    y1: 937.88,
    x2: -209.18,
    y2: 937.88,
    gradientTransform: "matrix(-0.98, -0.22, -0.22, 0.98, 1489.45, 81.28)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1448.17,
    y1: 841.76,
    x2: 1512.17,
    y2: 716.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -233.77,
    y1: 615.84,
    x2: -189.09,
    y2: 615.84,
    gradientTransform: "matrix(-0.98, -0.22, -0.22, 0.98, 1489.45, 81.28)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1603.15,
    y1: 772.33,
    x2: 1628.15,
    y2: 851.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1518.52,
    y1: 692.43,
    x2: 1561.52,
    y2: 693.93,
    gradientTransform: "matrix(0.99, 0.04, 0.04, 0.89, -6.51, 17.71)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -89.12,
    y1: -1281.54,
    x2: -44.31,
    y2: -1327.51,
    gradientTransform: "matrix(-0.67, -0.7, -0.72, 0.56, 587.74, 1421.53)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1543.62,
    y1: 847.91,
    x2: 1545.62,
    y2: 1211.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1273.02,
    y1: 1236.86,
    x2: 1794.56,
    y2: 1236.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1273.02,
    y1: 1253.24,
    x2: 1794.56,
    y2: 1253.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1273.02,
    y1: 1269.61,
    x2: 1794.56,
    y2: 1269.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1273.02,
    y1: 1285.99,
    x2: 1794.56,
    y2: 1285.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1273.02,
    y1: 1302.36,
    x2: 1794.56,
    y2: 1302.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 788.28,
    y1: 1175.63,
    x2: 825.42,
    y2: 1175.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 871.55,
    y1: 1277.29,
    x2: 917.62,
    y2: 1277.29,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2029.92,877.4q-28.89-94.33-57.79-188.66c-6.78-22.11-13.58-44.33-16.7-67.19-10.37-75.76,35.59-134.85,54.7-204.46,15.27-55.62,28.73-124.39,21.67-181.63-2.72-22-8.34-44.08-20-63.18-14.62-24-37.83-42-62.3-56.54C1865.75,65.81,1770.35,57.27,1674.66,74c-97.9,17.07-183.16,53-285.92,36C1265.52,89.48,1157.69,11.11,1033,1.1,926.87-7.42,824.19,34.85,728.41,78.86c-82.06,37.7-166,79.14-257.54,91.49-79.52,10.73-157.23-42-233.41-58.37C155.63,94.4,55.08,128.26,27.4,208.66c-25.61,74.4,4.83,161,28.13,232.48C83.37,526.5,108,612.43,90.74,702.42,81.31,751.63,62,798.65,43.63,845.67c-27.86,71.29-55.85,139-18.22,212.76,38.62,75.73,125.41,81.81,208.43,85,97.56,3.7,195.12-2.27,292.68-2.27h1252c58.63,0,130.09-12.58,182.19-36.89,63.77-29.76,80.28-81.05,83.62-140.48C2046.08,933.23,2038.83,906.46,2029.92,877.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1589.12,1245.9c70.76,14.15,161.13-63,190.24-147.28,30-86.73-25-123.07-24.55-243.42.48-136.72,71.6-157.32,118.64-341.61,10.62-41.57,72-282.18-4.09-327.28-70.38-41.7-268.09,78-302.74,231.14-24.71,109.22,51.67,155.08,22.5,282.29-25.59,111.61-92.86,113.23-118.64,220.92C1439.1,1051.76,1496.21,1227.32,1589.12,1245.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1594.26,1279c-19.07-147.3,18.14-374.55,52.71-539.26,37.44-178.31,79.93-323.77,80.35-325.22l5.89,1.73c-.43,1.45-42.85,146.71-80.24,324.8-34.47,164.22-71.59,390.72-52.62,537.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1670.61,1229.45C1577.79,1181.09,1546,1015,1598.79,961c35.65-36.47,86.77,1.89,136.09-35.92,63-48.26,16.65-139.17,66.16-257.07,42.13-100.33,143.2-195.27,202.25-175.79,61.82,20.39,94.39,171.69,41.59,262.74-34.33,59.22-86.89,62.13-98.29,117.2-13.23,63.9,50.68,93,51,155C1998.25,1138.48,1793.41,1293.43,1670.61,1229.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1720.7,1272a3.71,3.71,0,0,1-1.64-.38,3.78,3.78,0,0,1-1.76-5c123.06-253.56,159.14-547.72,159.49-550.66a3.78,3.78,0,0,1,7.51.89c-.35,3-36.59,298.38-160.19,553.07A3.78,3.78,0,0,1,1720.7,1272Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1973.16,792.06a1.8,1.8,0,0,1-1.42-2.91c38.84-49.86,81.89-124.76,66.39-198.47-9.23-43.9-35.2-66.8-35.46-67a1.8,1.8,0,1,1,2.36-2.73c1.1,1,27.16,23.92,36.64,69,8.71,41.44,4.14,110-67.08,201.44A1.83,1.83,0,0,1,1973.16,792.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1662.25,1207.31a1.82,1.82,0,0,1-1.5-.79c-59.69-87.11-80-154.43-60.5-200.07,17.38-40.57,61.26-48.12,61.7-48.2a1.81,1.81,0,1,1,.58,3.57c-.42.07-42.4,7.35-59,46.1-19,44.43,1.25,110.56,60.17,196.56a1.8,1.8,0,0,1-.46,2.51A1.78,1.78,0,0,1,1662.25,1207.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M467.39,1207.39c-77.66,14-178.43-52.61-211.89-126.87-34.44-76.42,25.42-109.83,22.94-216.73-2.83-121.44-81.46-138.26-136.34-301-12.38-36.71-84-249.16-1-290.81,76.79-38.5,296.44,63.69,337.16,199,29,96.51-54.29,138.83-20,251.22,30,98.62,104.13,98.65,134.31,193.77C629.28,1031.82,569.36,1189,467.39,1207.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M463.79,1292.24c14.48-131.16-22.39-332.4-55.87-478.13C371.68,656.34,331.5,527.85,331.1,526.57l-5.2,1.64c.4,1.28,40.52,129.59,76.72,287.16,33.38,145.3,70.14,345.88,55.75,476.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.93,1250.82c72.07-39.3,94.52-170,52.35-211.54-28.5-28.07-68,2.77-107.26-26.15-50.09-36.92-15.11-108.89-55.68-200.6-34.53-78.06-115.18-151-161.2-134.86C3,694.58-20.33,813.7,22.42,884.32c27.8,45.92,69.05,47.43,78.81,90.44,11.32,49.92-38.37,73.72-37.73,122.3C64.66,1184.34,227.58,1302.81,322.93,1250.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.28,1284.91a2.82,2.82,0,0,0,1.28-.32,3,3,0,0,0,1.3-4c-100.25-197-132.9-427.14-133.22-429.44a3,3,0,1,0-5.87.81c.32,2.31,33.11,233.43,133.81,431.32A3,3,0,0,0,284.28,1284.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.17,911.9a1,1,0,0,1-.77-.37c-25.19-31.1-42.35-61.53-51-90.44-6.94-23.19-8.45-45.45-4.5-66.18,6.74-35.35,27.37-54.24,27.58-54.43A1,1,0,0,1,51.81,702c-.2.18-20.39,18.7-27,53.44-6.08,32.1-1.46,85,55.11,154.86a1,1,0,0,1-.15,1.41A1,1,0,0,1,79.17,911.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M329.13,1232.92a1,1,0,0,1-.55-.17,1,1,0,0,1-.28-1.38c24.63-37.45,40.39-70.54,46.83-98.34,5.23-22.57,4.38-41.79-2.54-57.12-13.69-30.37-46.9-35.44-47.23-35.49a1,1,0,1,1,.28-2c.35,0,34.64,5.29,48.78,36.65,7.09,15.74,8,35.39,2.66,58.39-6.5,28-22.35,61.34-47.11,99A1,1,0,0,1,329.13,1232.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1583.27,
    cy: 313.7,
    r: 296.53,
    transform: "translate(241.91 1211.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1583.27,
    cy: 313.7,
    r: 253.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1583.27,575.81c-144.53,0-262.12-117.58-262.12-262.11S1438.74,51.58,1583.27,51.58s262.11,117.59,262.11,262.12S1727.8,575.81,1583.27,575.81Zm0-506.15c-134.57,0-244,109.48-244,244s109.47,244,244,244,244-109.48,244-244S1717.83,69.66,1583.27,69.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1583.27,
    cy: 313.7,
    r: 154.29,
    transform: "translate(241.91 1211.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1583.27,477c-90.06,0-163.33-73.26-163.33-163.32s73.27-163.33,163.33-163.33,163.32,73.27,163.32,163.33S1673.33,477,1583.27,477Zm0-308.57c-80.09,0-145.25,65.16-145.25,145.25S1503.18,459,1583.27,459s145.24-65.16,145.24-145.25S1663.36,168.45,1583.27,168.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1583.27,
    cy: 313.7,
    r: 59.78,
    transform: "translate(978.86 1810.31) rotate(-79.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1583.27,382.51a68.82,68.82,0,1,1,68.81-68.81A68.89,68.89,0,0,1,1583.27,382.51Zm0-119.55A50.74,50.74,0,1,0,1634,313.7,50.8,50.8,0,0,0,1583.27,263Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1743.27,
    y: -9.71,
    width: 8.77,
    height: 332.16,
    transform: "translate(2872.88 1502.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1631.51,255.74c3.55-3.56,20.33,13.22,16.77,16.78l-62.22,48.91a2.47,2.47,0,0,1-3.47-3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1868.06,42.17l31.59,3.14-43.37,43.38A67.08,67.08,0,0,1,1802.22,108h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1861.85,36l-3.14-31.6-43.38,43.38A67.05,67.05,0,0,0,1796,101.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1511.09,405.13h254.7a66,66,0,0,1,66,66v816.69a0,0,0,0,1,0,0H1445.08a0,0,0,0,1,0,0V471.14A66,66,0,0,1,1511.09,405.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1397.09,405.13h254.7a66,66,0,0,1,66,66v816.69a0,0,0,0,1,0,0H1331.08a0,0,0,0,1,0,0V471.14A66,66,0,0,1,1397.09,405.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1363,565.83a2.45,2.45,0,0,1-2.45-2.45v-67a64,64,0,0,1,63.94-63.94h101.68a2.45,2.45,0,0,1,0,4.9H1424.49a59.11,59.11,0,0,0-59,59v67A2.44,2.44,0,0,1,1363,565.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1363,636.88a2.45,2.45,0,0,1-2.45-2.45v-27.3a2.45,2.45,0,1,1,4.9,0v27.3A2.45,2.45,0,0,1,1363,636.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1140.23,594.38h212.52a55.08,55.08,0,0,1,55.08,55.08v681.45a0,0,0,0,1,0,0H1085.15a0,0,0,0,1,0,0V649.46A55.08,55.08,0,0,1,1140.23,594.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1045.1,594.38h212.52a55.08,55.08,0,0,1,55.08,55.08v681.45a0,0,0,0,1,0,0H990a0,0,0,0,1,0,0V649.46A55.08,55.08,0,0,1,1045.1,594.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1016.66,728.47a2,2,0,0,1-2-2V670.52A53.41,53.41,0,0,1,1068,617.17h84.84a2,2,0,1,1,0,4.09H1068a49.32,49.32,0,0,0-49.27,49.26v55.91A2,2,0,0,1,1016.66,728.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1016.66,787.75a2,2,0,0,1-2-2V762.93a2,2,0,0,1,4.08,0v22.78A2,2,0,0,1,1016.66,787.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M822.53,746.52H1040a55.08,55.08,0,0,1,55.08,55.08v529.32a0,0,0,0,1,0,0H767.45a0,0,0,0,1,0,0V801.59A55.08,55.08,0,0,1,822.53,746.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M739.29,746.52h217.5a55.08,55.08,0,0,1,55.08,55.08v529.32a0,0,0,0,1,0,0H684.22a0,0,0,0,1,0,0V801.59A55.08,55.08,0,0,1,739.29,746.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M706.19,855.67a2,2,0,0,1-2.05-2V812.17a40.14,40.14,0,0,1,40.1-40.09h62.92a2,2,0,1,1,0,4.08H744.24a36.05,36.05,0,0,0-36,36v41.46A2,2,0,0,1,706.19,855.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M706.19,899.64a2.05,2.05,0,0,1-2.05-2V880.7a2,2,0,0,1,4.09,0v16.89A2.05,2.05,0,0,1,706.19,899.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M535.23,918.15H707.4a55.08,55.08,0,0,1,55.08,55.08v357.69a0,0,0,0,1,0,0H480.15a0,0,0,0,1,0,0V973.23A55.08,55.08,0,0,1,535.23,918.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M452,918.15H624.17a55.08,55.08,0,0,1,55.08,55.08v357.69a0,0,0,0,1,0,0H396.92a0,0,0,0,1,0,0V973.23A55.08,55.08,0,0,1,452,918.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.22,1035.73a2,2,0,0,1-2-2V984.77a47,47,0,0,1,46.93-46.94h74.24a2,2,0,1,1,0,4.09H465.11a42.89,42.89,0,0,0-42.84,42.85v48.92A2.05,2.05,0,0,1,420.22,1035.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M420.22,1087.6a2.05,2.05,0,0,1-2-2v-19.93a2,2,0,0,1,4.09,0v19.93A2.05,2.05,0,0,1,420.22,1087.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M264.6,1125.79H436.78a55.08,55.08,0,0,1,55.08,55.08v150a0,0,0,0,1,0,0H209.53a0,0,0,0,1,0,0v-150A55.08,55.08,0,0,1,264.6,1125.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M181.37,1125.79H353.55a55.08,55.08,0,0,1,55.08,55.08v150a0,0,0,0,1,0,0H126.3a0,0,0,0,1,0,0v-150A55.08,55.08,0,0,1,181.37,1125.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M146.37,1240a2.05,2.05,0,0,1-2.05-2V1189a47,47,0,0,1,46.94-46.94h74.23a2,2,0,1,1,0,4.09H191.26A42.9,42.9,0,0,0,148.41,1189v48.91A2,2,0,0,1,146.37,1240Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M146.37,1291.85a2,2,0,0,1-2.05-2v-19.93a2,2,0,0,1,4.09,0v19.93A2,2,0,0,1,146.37,1291.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M835.26,186.79l-28.65,65.9c23.84,32,47,48,68.55,53.79-.09-22.4,9.6-42.64,17.15-55C853.29,237.24,835.26,186.79,835.26,186.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M978.3,226.12c-35.62,30-64.11,33.41-86,25.4-7.55,12.32-17.24,32.56-17.15,55,68.37,18.55,119.59-65.62,119.59-65.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M982.16,235.93s-13.8-16.82-.85-33.68c0,0,4-6.48,10.83.9,0,0,14-17.76,19.53-12.48s20,18.22,11.18,37.24C1013.92,247.15,988.78,243.46,982.16,235.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M996.71,223.22a9.66,9.66,0,0,1-5.16-.4c-1.68-.64-3.92-2.21-5-6a2.34,2.34,0,0,1,4.48-1.35c.7,2.34,1.87,2.8,2.25,3a7.1,7.1,0,0,0,4.65-.39l-5.54-10.86a2.34,2.34,0,0,1,4.17-2.12l6.64,13a2.34,2.34,0,0,1-.88,3.07A17.27,17.27,0,0,1,996.71,223.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M485.65,719.1a10.35,10.35,0,0,0-2.58,11.43c6,16.26,24.09,58.86,54.24,80.8a3.92,3.92,0,0,0,5.67-.93c-7.66-5.7-17.69-15.95-30.44-34.07C492.93,748.47,487.11,730.24,485.65,719.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M518.78,712.89s-18.11-6.24-33,6.11c0,0-.06.07-.1.1,1.46,11.14,7.28,29.37,26.89,57.23,12.75,18.12,22.78,28.37,30.44,34.07a4.55,4.55,0,0,0,.76-2.07C545.75,790.72,548.13,742.34,518.78,712.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M542.93,709.91l-12.62,17a8,8,0,0,1-9.66,2.57,20.91,20.91,0,0,1-9.22-8.14,8,8,0,0,1,0-8.63l12.24-19a8,8,0,0,1,12.89-.83l6,7.15A8,8,0,0,1,542.93,709.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1000.36,553.39a10.35,10.35,0,0,0,11.71.2c14.69-9.22,52.73-35.56,68.09-69.55a3.93,3.93,0,0,0-2.07-5.36c-4,8.66-12,20.57-27.17,36.74C1027.63,540.29,1011,549.7,1000.36,553.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M987.54,522.22s-2.42,19,12.7,31.09l.12.08c10.61-3.69,27.27-13.1,50.56-38,15.15-16.17,23.15-28.08,27.17-36.74a4.69,4.69,0,0,0-2.18-.32C1058.26,480,1010.4,487.49,987.54,522.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M988.68,499.11l18,11.05a8,8,0,0,1,3.42,9.39,21,21,0,0,1-7.28,9.91,8,8,0,0,1-8.61.73L974.18,519.7a8,8,0,0,1-2-12.76l6.59-6.64A8,8,0,0,1,988.68,499.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M650.11,413.48S637,523.1,624.87,572.34c0,0-33.77,11.1-53.11,27.24s-53.89,93.36-53.89,93.36,15.91,20.88,31.06,21.95L665.16,601.67,749.63,462l-14.48-55.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M650.57,404.64l-4.17,30.11s20.8,73.63,113.23,45.11,101.72-46,101.72-46-.16,49.28,112.9,89.52c0,0,13.72-14.51,14.92-28.56L896.66,387.61c-12.7-14-22.74-16.53-40.66-10.56-39.62,13.19-114.42,34.28-126.28,34.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M688.71,179.52c-27.32,6-68.68,26.43-92.47,57.06,10.25,8.09,26.17,21.38,38.66,35,7.46-9.81,19-18.88,36.2-26.33C665.33,305.79,656.29,364,642.58,419a6.08,6.08,0,0,0,4.86,7.49c18.27,3.11,71.58,8.9,108.54-21l68.77-144.83a112.43,112.43,0,0,0,10.86-49.88l-.35-24S748.23,166.38,688.71,179.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M672.27,384c-5.4-8-20.23-13.89-27.24-16.3-7.53-10.59-38.56-58.69-10.13-96-12.49-13.67-28.41-27-38.66-35C568.8,271.91,564.8,320.86,632.76,377c-.39,16.71,12.91,33.86,18.84,35.59C654.33,413.41,679.43,394.63,672.27,384Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M676.38,244.71a2.34,2.34,0,0,1-1.25-4.48l24.26-9.66a2.34,2.34,0,0,1,1.73,4.35l-24.26,9.65A2.18,2.18,0,0,1,676.38,244.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M744.08,134.82,728.2,185.08a7.75,7.75,0,0,0,2.54,8.41c6.8,5.42,22.07,13.51,44.35,2.14A7.23,7.23,0,0,0,779,189l-.9-43.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M792.72,83.68s11.87,33.18,11.67,50.17,2.71,28.21-17.08,30.3-35.62-8.76-43.42-26.22c0,0-12.24-26.91-8.39-37.34S792.72,83.68,792.72,83.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M751.39,126.26l1.15-.42a2.69,2.69,0,0,0,1.56-3.6c-2.4-5.51-7-18.09.18-20.47,9.21-3.07,45.16-7.92,53.66-20,8.17-11.6,2.71-27.66-6.79-32.76a1.35,1.35,0,0,0-1.8.46L798.43,51a1.34,1.34,0,0,1-2.44-.42h0a1.33,1.33,0,0,0-2.37-.5c-2.61,3.61-9.37,9.28-26.56,11.27C742.62,64.16,726,72.85,724.48,89.5a1.33,1.33,0,0,1-2.13,1c-1.71-1.2-4.52-1.91-8.55,1-7,5.13-5.27,19.77,8.47,32.64a1.33,1.33,0,0,1-.21,2.13c-2.75,1.54-6.95,5.35,2.86,11.48,10.15,6.33,18,6.4,21.1,6.1a1.32,1.32,0,0,0,1.18-1.52L745,127.45a1.34,1.34,0,0,1,1.41-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M751.79,129.39s-4-20.95-13.59-15.8,3.24,23.4,10.61,24.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1585.01,
    y: 942.14,
    width: 11.7,
    height: 126.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1642.09,1071.09H1539.63v-3.22a4.38,4.38,0,0,1,4.39-4.39h93.33a4.74,4.74,0,0,1,4.74,4.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1524.55,
    y: 912.01,
    width: 136.91,
    height: 38.83,
    rx: 13.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1487.16,1030.23s-37.82,16.29-35.66,33.34c0,0,39.1-7.5,46.09-18.67s3.14-17.65,3.14-17.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1496.42,1011.61l1.92,16.6a5.48,5.48,0,0,1-3.48,5.83,14.21,14.21,0,0,1-4.79.73,6.39,6.39,0,0,1-6.21-4.66l-3.72-13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1579,884.33s-69.56-3.22-104.18,17,1.76,117.06,1.76,117.06,9,1.95,22.06-5c0,0-18.58-70.92,13.69-83.26,36.29-13.87,73.82-10.5,73.82-10.5l-7-33.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1459.1,1056.09c7.91-1.73,31.37-11.45,34.93-11.32s8.61,5.47,8.61,5.47.87,2.91-1.68,7.1c-6,4.71-19.06,13.37-34.2,14.31-11.13.7-17.83-3.73-21.66-8A31,31,0,0,1,1459.1,1056.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1466.76,1071.65c15.14-.94,28.16-9.6,34.2-14.31-1.72,2.83-5,6.24-11.17,9.73-15.29,8.64-40.57,7.38-45.59,5.43-4-1.55-2.77-5.3.9-8.88C1448.93,1067.92,1455.63,1072.35,1466.76,1071.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1510.94,1041.55c-.51,2-6,7.84-9.26,11.12a6.28,6.28,0,0,1-5.86,1.76,15.88,15.88,0,0,1-4.19-1.47,4.08,4.08,0,0,1-1.58-5.56l8.1-14.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1648,878.5s6.08,43.07-11.48,51.88-56.06,14.56-69.33,36.91-37.08,66.19-58.76,78.79c0,0-12.38-4-16-10.12,0,0,25.73-67.64,36.46-84.08,9.3-14.24,22.89-34.75,42.2-43.62,5.53-2.54,6-8.4,5-14.41l-1.77-10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1485.26,829.67c24.61,7,35.63-62.25,35.53-63.93l37.74,44.12s-22.49,39.57-56.44,43.78a40.11,40.11,0,0,1-22-3.23A35.26,35.26,0,0,0,1485.26,829.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1439.68,807c10.73-4.41,19.83,4.39,19.83,4.39,10.63,10.88,19.06,16.38,25.75,18.29a35.26,35.26,0,0,1-5.2,20.74c-13.26-6.08-21-18.36-24.17-24.49a4.61,4.61,0,0,0-6.07-2.06c-2.28,1.1-4.62,2.78-4.77,5.06-.29,4.49-5.63,4.76-5.67,3.1s4.14-10.54,4.14-10.54-12.32,7.91-17.12,10.93-8.88-2-8.88-2S1429,811.4,1439.68,807Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1638.49,737.23s-33.07-22.56-113,18.25c0,0-8.22,10.43-4.37,22.18s51.28,75.38,53.13,105.25c0,0,32.42,19.09,74.51.17C1648.8,883.08,1662.91,804.21,1638.49,737.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1569.62,708.38,1582.69,734a7.28,7.28,0,0,1-.75,7.85c-3.6,4.51-11.12,10.57-23.94,6.66a11.22,11.22,0,0,1-7.66-8.14l-6.77-28.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1663,826.67c2.24-15.57-38.91-45.74-38.91-45.74l14.41-43.7s78.51,56,62,101.78a32.07,32.07,0,0,1-10.2,14.73C1682,836.69,1670.7,829.6,1663,826.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1605.59,831s46.54,13,56.19-1.17a7.42,7.42,0,0,0,1.21-3.15c7.71,2.93,19,10,27.3,27.07-22.1,17.38-64.7-2.11-76.28-8a8.15,8.15,0,0,0-6.13-.51c-4.12,1.28-11.25,3.28-15.23,3.06-5.81-.32-12.05,20.7-22,15.38C1570.7,863.72,1575.2,827.81,1605.59,831Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1550.12,674c-.53.41-22.43,37.42-22.43,37.42l24.68,12.69,26.78-31.84S1559,667.14,1550.12,674Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1568.05,695.26l-12.55,17.88a2.54,2.54,0,0,1-.58.6c-1.39,1.08-6.5,4.44-10.42-.81-3.56-4.78-6.88-9.09-10.51-10.66a3.36,3.36,0,0,0-4.27,1.13,115.1,115.1,0,0,0-8.89,18.3,3.22,3.22,0,0,0,2,3.88c4.89,2.19,15.32,6.55,24.45,8.34a3.36,3.36,0,0,0,3.2-1c3.6-4.17,14.59-16.8,18.3-19.84,3.47-2.86,10-1.06,12.63-.13a3.63,3.63,0,0,0,2.62-.07c2.82-1.24,8.46-4.8,3.39-12.15a2.8,2.8,0,0,1,1.06-4.24c3.28-1.58,7.16-4.87,3.76-11.11s-9.79-7.13-13.83-6.9a3.75,3.75,0,0,1-3.7-2.36,2.91,2.91,0,0,0-2.45-1.84,3.32,3.32,0,0,1-2.8-3.89c.83-3.27.47-7.77-5.53-11.22-10.65-6.12-20,1.79-22.4,8.9s9.51,13.17,17,14.61c5.7,1.1,8.72,7.13,9.84,10A2.7,2.7,0,0,1,1568.05,695.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1564.09,719.56s4.77-12.17,10.84-11.25,10.83,6.77,3.29,12.33C1568.85,727.56,1564.09,719.56,1564.09,719.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1546.16,860.62h-.25l-108.72-.12a4.87,4.87,0,1,1,0-9.73l108.72.12a4.86,4.86,0,0,1,.24,9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1339.44,761.91H1430a17.26,17.26,0,0,1,15.61,9.89l41.86,88.77H1374.93a10.48,10.48,0,0,1-9.75-6.64l-32.46-82.13A7.23,7.23,0,0,1,1339.44,761.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1403.24,807.42c2,6.09.51,12-3.24,13.22s-8.38-2.75-10.34-8.85-.52-12,3.23-13.22S1401.27,801.32,1403.24,807.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1354.12,1093.82a4.59,4.59,0,0,1-1.8-.36,4.37,4.37,0,0,1-2.39-5.81L1445.75,872a4.63,4.63,0,0,1,6-2.31,4.38,4.38,0,0,1,2.39,5.81l-95.83,215.66A4.57,4.57,0,0,1,1354.12,1093.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1462.07,1093.82a4.59,4.59,0,0,1-4.2-2.67l-95.82-215.66a4.36,4.36,0,0,1,2.39-5.81,4.63,4.63,0,0,1,6,2.31l95.82,215.66a4.37,4.37,0,0,1-2.39,5.81A4.6,4.6,0,0,1,1462.07,1093.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1650.74,1093.82a4.64,4.64,0,0,1-1.81-.36,4.38,4.38,0,0,1-2.39-5.81L1742.37,872a4.62,4.62,0,0,1,6-2.31,4.36,4.36,0,0,1,2.39,5.81l-95.82,215.66A4.59,4.59,0,0,1,1650.74,1093.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1758.69,1093.82a4.58,4.58,0,0,1-4.2-2.67l-95.83-215.66a4.37,4.37,0,0,1,2.4-5.81,4.62,4.62,0,0,1,6,2.31l95.82,215.66a4.37,4.37,0,0,1-2.39,5.81A4.59,4.59,0,0,1,1758.69,1093.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1769.93,865.33a5.26,5.26,0,0,0-.91-4,4.13,4.13,0,0,0-3.33-1.76H1329.77a4.87,4.87,0,0,0-4.18,2.56,6.16,6.16,0,0,0-.33,5.33l4.73,11.44a6.61,6.61,0,0,0,6,4.3H1762.7a5.19,5.19,0,0,0,4.92-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1256.31,1324.54h551.16V1214.23H1256.31C1268.1,1214.23,1268.1,1324.54,1256.31,1324.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1807.47,1296.94v-50.49c0-17.79-10.89-32.22-24.32-32.22H1258.63a19.13,19.13,0,0,1-19.13-19.13h0a5.82,5.82,0,0,1,5.81-5.82h573.26c13.14,0,34,20.67,34,46.17V1306c0,24-20.27,43.53-32.66,43.53h-571.6a8.83,8.83,0,0,1-8.83-8.83,16.12,16.12,0,0,1,16.11-16.12h531C1798.14,1324.54,1807.47,1312.18,1807.47,1296.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1792.19,1239.23h-516.8a2.37,2.37,0,1,1,0-4.73h516.8a2.37,2.37,0,1,1,0,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1792.19,1255.6h-516.8a2.37,2.37,0,1,1,0-4.73h516.8a2.37,2.37,0,1,1,0,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1792.19,1272h-516.8a2.37,2.37,0,0,1,0-4.74h516.8a2.37,2.37,0,1,1,0,4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1792.19,1288.35h-516.8a2.37,2.37,0,1,1,0-4.73h516.8a2.37,2.37,0,1,1,0,4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1792.19,1304.73h-516.8a2.37,2.37,0,0,1,0-4.74h516.8a2.37,2.37,0,1,1,0,4.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1302.75,
    y: 1034.07,
    width: 495.95,
    height: 119.71,
    rx: 7.31,
    transform: "translate(3101.44 2187.85) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1684.38,
    y: 1047.83,
    width: 58.26,
    height: 92.2,
    rx: 10.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1653.95,
    y: 1047.83,
    width: 21.86,
    height: 92.2,
    rx: 8.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M315.26,813.27s-19,9.24-22.48,19.84c-2.8,8.52-23.79,9.61-25.87,26.35a19.2,19.2,0,0,1-16.07,16.89c-21.44,3.28-54.48,14.42-59.77,51.64-4,28.41,10.45,39.19,25.65,42.92,11.17,2.74,18.59,13.6,16.33,24.87-2.17,10.81,1.06,23.31,19.79,33.19,42,22.15,83.89-52.47,83.89-52.47l8.59-130.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M447.82,779.84s-40.88,87.58-99.8,111c0,0,16.19,32.3,25.85,35,0,0,67-72.11,78.51-134.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M213.43,1321.78l-1.67,13.76a5.68,5.68,0,0,1-5,5,88.35,88.35,0,0,1-18.41.29,4.87,4.87,0,0,1-4.09-6.32c1.69-5.31,4.78-13.28,9.23-18h15.27A4.7,4.7,0,0,1,213.43,1321.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M333,1160.59l2.57,15.15s-8.63,87.4-10.16,122.36a27.42,27.42,0,0,0,4,15.56l15,24.37-38.13-22.5-.76-4.65,6.24-8.59-8.18-97.9a30.09,30.09,0,0,1,3.42-16.62L315,1173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M347,1341.56H334.81a7.35,7.35,0,0,1-5.82-2.85c-3.79-4.93-11.65-14.55-15.41-14.8-5.06-.34-4.41,17.65-4.41,17.65h-2.83l-3.6-22.35a13.25,13.25,0,0,1,6.95-13.83h0s1.15,8.55,7.42,12.34,25.52,17.33,25.52,17.33a17.28,17.28,0,0,1,4.95.13C351.41,1335.87,350.88,1341.56,347,1341.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M280.77,1167.78s-50.55,95.89-58.58,117.78-10.85,40.15-11,41.88c-.17,2.7-3.53,5.29-12.79,5.29-4.78,0-7.13-1.91-8.27-3.77a5.41,5.41,0,0,1-.21-5.23c2.93-5.92,12.21-24.83,15.64-33.4,4.11-10.24,12.93-56.65,17.77-72.79s10.31-33.63,31.39-49.76C254.76,1167.78,269.23,1153.61,280.77,1167.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M312.7,1010.68c13-55.25-20-86.5-20-86.5,20.84-20,58.81-29.11,58.81-29.11s36.24,26.49,31.94,47.22c-2.52,12.16-25.47,72.8-25.47,72.8S336.77,1025.13,312.7,1010.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M283.79,1038c5.31-16,28.91-27.35,28.91-27.35,24.07,14.45,45.29,4.41,45.29,4.41s4.76,18.19,1.48,35.1-23.9,125.55-23.9,125.55c-32.47,6.58-82.41-6.62-82.41-6.62C273.84,1132.4,278.49,1054,283.79,1038Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M327.84,858.56l-10.6,47.61c-1,4.2,2.8,3.51,7,2.71,7-1.31,15.9-4,18.89-9.41a4.89,4.89,0,0,0,.54-1.79l4.56-33a5.94,5.94,0,0,0-3.47-6.23l-8.79-3.9A5.93,5.93,0,0,0,327.84,858.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M292.71,924.18s-74,52.93-9.46,108.55a16.66,16.66,0,0,0,7.3,4.24c2.44.73,9.67,6.19,13.33,9a2.53,2.53,0,0,0,3.68-.66h0a3.44,3.44,0,0,0,.19-3.29l-9.16-19.37a7.07,7.07,0,0,0-9.18-.4h0a3.48,3.48,0,0,1-5.28-1.2c-5-10.16-14.41-40,24.14-73.8a4.17,4.17,0,0,0,.93-5.07C306.49,937,300.3,926.69,292.71,924.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M340.27,813.22s12.56,5.3,21.1,23.44,2.16,26.52-5.85,27.67-20,1-32.65-10.74S324,806.93,340.27,813.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M331.38,843.9s-9.47-26.54,14.07-26.86l5.53,3.87s8.64-14.71-5.53-21.74S314.69,798,308.66,817s-7.06,31.88,3,41,14.17-1.22,14.17-1.22-5.47-8.54-3.24-13.11,7.35.94,7.35.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M328.75,846.86s-4.79-13.68-11.18-8.23,5.19,12.63,9.72,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M444.72,792.49c.51,1.61-5.37,4.07-8.84-2.53-.12-3.17-2-16.73-.15-19.3,10.07-13.73,29.6-30.94,29.6-30.94a4.64,4.64,0,0,1,.58,6.45L456.43,756c2,3.58,4.4,6.6,5.54,10.93a13.3,13.3,0,0,1-1.33,9.77c-1.66,3-3.93,6.89-6.07,9.94A13.14,13.14,0,0,1,444.72,792.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M449.14,785.67l-1-.18c.11-.59,2.63-14.58,4.58-17.76a4.41,4.41,0,0,0,.9-3.24,2.55,2.55,0,0,0-1.28-1.45l-8.27,7-2.66,7.17-.94-.35,2.76-7.41,9-7.62.3.15a3.69,3.69,0,0,1,2.07,2.23c.31,1.11,0,2.43-1,4C451.73,771.27,449.16,785.52,449.14,785.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M913.54,1345.28s45.84-57.6,38.39-112-44.65-48-61.2-15.75-31.44,27.78-21.6-2.49,22.16-50,1.78-80.11-22.49-42.94-11-69.83,25.83-65-19.73-78.58-90.94,28.17-80.32,82.83,17,60.62,2.37,80.87-8.53,28.56-6.46,41.74-20.28,16.27-19.8-2.3,28.91-62.37,9.5-82.81-57.45-20.66-67.2,26.6,21.48,68.5,19.92,85.59-18.32-8.82-32.92,8.6,5.06,31.12,19.53,40.56,36.28,26.36,15.52,38.65-40.41.53-27.69,38.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M819.3,1025.89a23.72,23.72,0,0,0-4.08,2.86,31.89,31.89,0,0,0-3.55,3.52,40.2,40.2,0,0,0-5.59,8.33,52.5,52.5,0,0,0-5.21,19.43c-.1.84-.13,1.68-.17,2.52s-.08,1.68-.06,2.52v2.52l.12,2.52.07,1.26.13,1.25.25,2.5c.25,1.65.42,3.32.74,5s.6,3.29,1,4.91l.56,2.44.58,2.35,2.34,9.42c3.1,12.54,6.09,25.07,8.43,37.68s3.87,25.32,3.51,37.9a91,91,0,0,1-.69,9.36,69.81,69.81,0,0,1-1.72,9.14,58.29,58.29,0,0,1-3,8.7,65.78,65.78,0,0,0-3.25,9.7,157.77,157.77,0,0,0-3.2,19.58c-.68,6.52-1.21,13-1.64,19.48-.89,12.94-1.65,25.84-3.52,38.57-.23,1.59-.48,3.18-.78,4.75s-.6,3.15-.93,4.72-.73,3.12-1.09,4.68c-.21.77-.44,1.54-.65,2.31s-.43,1.54-.7,2.29l-.77,2.27c-.26.76-.58,1.49-.87,2.23-.56,1.51-1.29,2.92-2,4.38a39.48,39.48,0,0,1-5.36,7.91l.52.51a41.17,41.17,0,0,0,6.13-7.7,61.57,61.57,0,0,0,4.32-8.87,111.81,111.81,0,0,0,5.36-18.91c2.64-12.83,3.89-25.82,5.31-38.7.72-6.44,1.36-12.86,2.24-19.22a151.31,151.31,0,0,1,3.61-18.69,64.34,64.34,0,0,1,3.09-8.66,64.77,64.77,0,0,0,3.47-9.63,75.8,75.8,0,0,0,2.06-9.93,96.73,96.73,0,0,0,.93-10c.55-13.37-1.11-26.53-3.34-39.44s-5.36-25.61-8.81-38.16c-.87-3.13-1.74-6.27-2.64-9.39l-.69-2.33-.62-2.28c-.44-1.52-.77-3-1.14-4.58s-.63-3.07-1-4.61l-.36-2.32c-.12-.78-.23-1.55-.31-2.33a73,73,0,0,1-.57-9.34,53.56,53.56,0,0,1,.78-9.3,50.75,50.75,0,0,1,2.4-9,45.47,45.47,0,0,1,1.92-4.28,35.54,35.54,0,0,1,2.38-4.08,31.16,31.16,0,0,1,6.31-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M916.89,1221a305.69,305.69,0,0,1-5.69,30.27c-1.19,5-2.51,9.94-4,14.84-.35,1.23-.76,2.44-1.13,3.66s-.78,2.44-1.18,3.65c-.78,2.44-1.65,4.83-2.51,7.24s-1.8,4.77-2.8,7.12-2,4.69-3,7c-2.16,4.61-4.44,9.17-7,13.59a146.93,146.93,0,0,1-8.28,12.84,138.92,138.92,0,0,1-9.81,11.81l.5.54a89,89,0,0,0,11.18-10.87,118,118,0,0,0,9.26-12.61,143.51,143.51,0,0,0,7.48-13.73c1.08-2.38,2.19-4.74,3.16-7.15s1.9-4.85,2.81-7.29,1.72-4.91,2.49-7.39c.4-1.24.77-2.48,1.12-3.73s.74-2.5,1.06-3.76c1.38-5,2.52-10.07,3.5-15.16a188.43,188.43,0,0,0,3.51-30.85Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceAugmentation4);
export default __webpack_public_path__ + "static/media/resource_augmentation_4.744f92168f1c6945d9b7abde7419c544.svg";
export { ForwardRef as ReactComponent };